module.exports = __webpack_public_path__ + "img/select.143bfc5f.svg";